/* eslint-disable max-len */
import React, { forwardRef } from 'react';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { cn } from '../utils';

const primaryClasses = 'px-8 py-3 text-sm disabled:opacity-80 text-center font-medium rounded-md focus:ring ring-primary/10 outline-none flex items-center justify-center gap-2 transition-opacity bg-black border border-black dark:border-white disabled:bg-gray-500 disabled:hover:bg-gray-500 text-white dark:bg-white dark:text-black hover:bg-gray-700 dark:hover:bg-gray-200 transition-colors';

library.add(faSpinner);

const Button = forwardRef(
  (
    {
      className,
      children,
      variant,
      brightness,
      isLoading,
      ...props
    },
    forwardedRef,
  ) => (
    <button
      className={cn([className, primaryClasses])}
      disabled={isLoading}
      type="submit"
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      ref={forwardedRef}
    >
      {children}
      {' '}
      {isLoading && <FontAwesomeIcon icon={faSpinner} spin />}
    </button>
  ),
);

Button.displayName = 'Button';
export default Button;
